module.exports = __webpack_public_path__ + "static/img/hezuo10.97fdf72.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/imgsrc/hezuo10.jpg
// module id = Zrtm
// module chunks = 1